import { render } from "./MarkLegend.vue?vue&type=template&id=464bdef8"
import script from "./MarkLegend.vue?vue&type=script&lang=js"
export * from "./MarkLegend.vue?vue&type=script&lang=js"

import "./MarkLegend.vue?vue&type=style&index=0&id=464bdef8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__